import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getMeQueryOptions } from '@/api/me';
import type { MutationConfig } from '@/lib/react-query';
import { api } from '@/lib/treaty';

type ChangeLanguageProps = Parameters<(typeof api.users.me)['change-language']['patch']>[0];

type UseChangeLanguageOptions = {
  mutationConfig?: MutationConfig<typeof changeLanguage>;
};

export const changeLanguage = (props: ChangeLanguageProps) => {
  return api.users.me['change-language'].patch(props);
};

export const useUpdateLanguage = ({ mutationConfig }: UseChangeLanguageOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...mutationConfig,
    mutationFn: changeLanguage,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: getMeQueryOptions().queryKey });

      return mutationConfig?.onSuccess?.(...args);
    },
  });
};
